import { ReactSVG } from 'react-svg';
import styled from 'styled-components';

export const RatingGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StarButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 0;
  height: fit-content;
  cursor: ${({ disabled }) => (disabled ? 'inherit' : 'pointer')};
  color: inherit;
  transition: transform 0.1s ease-in-out;
`;

export const EmptyStarIcon = styled(ReactSVG)<{ iconSize: number }>`
  svg {
    width: ${({ iconSize }) => iconSize}px;
    height: ${({ iconSize }) => iconSize}px;
    path {
      stroke: ${({ theme }) => theme.configs.CTAButton.bgColor};
    }
  }
`;

export const FullStarIcon = styled(ReactSVG)<{ iconSize: number }>`
  svg {
    width: ${({ iconSize }) => iconSize}px;
    height: ${({ iconSize }) => iconSize}px;
    fill: ${({ theme }) => theme.configs.CTAButton.bgColor};
    path {
      stroke: ${({ theme }) => theme.configs.CTAButton.bgColor};
    }
  }
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
